module.exports = __webpack_public_path__ + "images/cam-show-sommelier-1d4c5c3e2217d79b3baa86e685f19d5e.png";